import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCustomerTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: guid
        description: name
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

type Props = {
  isMulti?: boolean;
} & FsProps;

export const FieldSelectCustomerType = ({
  label = 'Κατηγορία',
  name = 'cstTypeGuid',
  isMulti = false,
  defaultValues = {},
  ...rest
}: Props) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.cstType?.name ?? undefined}
      isMulti={isMulti}
      hook={useGetValues}
    />
  );
};

